var shadows = {
    base: "0px 1px 0px rgba(0, 0, 0, 0.05)",
    modal: "0px 4px 40px rgba(0, 0, 0, 0.05)",
    toast: "0px 0px 8px rgba(0, 0, 0, 0.12)",
};

export { shadows as default };
//# sourceMappingURL=shadows.js.map
